<template lang="pug">

</template>

<script>
import { mapState, } from 'vuex'
import { Loading, } from 'element-ui'

export default {
  name: 'Loading',
  data () {
    return {
      globalLoading: null,
      loadingOptions: {
        lock: true,
        fullscreen: true,
        // text: 'Please, wait',
        // spinner: 'el-icon-loading',
        // background: 'rgba(0, 0, 0, 0.7)',
      },
    }
  },
  computed: {
    ...mapState([ 'loading', ]),
  },
  watch: {
    loading (value) {
      value ? this.startLoading() : this.endLoading()
    },
  },
  mounted () {
    if (this.loading) {
      this.startLoading()
    }
  },
  methods: {
    startLoading () {
      this.globalLoading = Loading.service(this.loadingOptions)
    },
    endLoading () {
      this.globalLoading.close()
    },
  },
}
</script>

<style scoped lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/layout-components/Loading.vue